import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import { Icon } from "components";
import { getArtieLogo, getIsMaximized } from "slices";
import { renderMascot } from "utils";
import ExtraOption from "components/OptionsBox/ExtraOptions/index";

export const extractAddress = (message) => {
  const urlMatch = message.match(/https:\/\/www\.google\.com\/maps\/place\/([^\s]+)/);

  if (!urlMatch) {
    return null;
  }

  const encodedPart = decodeURIComponent(urlMatch[1]); // decode %2C into ','
  const parts = encodedPart.split(",");
  const addressParts = parts.slice(-4); // keep only address, remove "true,true,true..."

  return addressParts.join(", ").replace(/\+/g, " ").trim();
};

export const createMapEmbedUrl = (address) => {
  return `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
};

const EmbedMapView = ({ isLastBot, staticImageData, isUserMsg, position, mascotSettings, customSize, message }) => {
  const artieLogo = useSelector(getArtieLogo);
  const isMaximized = useSelector(getIsMaximized);

  const address = extractAddress(message);
  const embedUrl = createMapEmbedUrl(address);
  const messageText = message.split("https://")[0].trim();

  return (
    <div style={{ overflowWrap: "break-word" }}>
      <div className={`hayley-flex ${isLastBot && (isMaximized ? "hayley-mb-4" : "hayley-mb-3")}`}>
        {isUserMsg ? (
          isMaximized ? (
            <Icon iconType="DefaultUser" classes={"hayley-h-9 hayley-w-9 hayley-object-cover"} />
          ) : (
            ""
          )
        ) : (
          <>
            {isEmpty(artieLogo) && <div className="hayley-h-9 hayley-w-9">{renderMascot(mascotSettings, position, true, customSize, false)}</div>}

            {!isEmpty(artieLogo) && (
              <div className="hayley-z-10 hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-rounded-full hayley-border hayley-border-[#EEE]">
                <img
                  id="staticImage"
                  src={artieLogo.includes("data:image/gif") ? staticImageData : artieLogo}
                  alt=""
                  className={`hayley-h-8 hayley-w-8 hayley-rounded-full hayley-object-cover`}
                />
              </div>
            )}
          </>
        )}
        <div className="hayley-mx-3">
          <div className="hayley-max-w-[725px] hayley-rounded-lg hayley-rounded-tl-none hayley-bg-custom-7 !hayley-px-4 !hayley-py-2 hayley-text-sm hayley-text-secondary">
            {/* {follow_up?.tour_not_scheduled?.text.length > 0 ? follow_up?.tour_not_scheduled?.text : t("wouldYouSchedule")} */}
            {messageText ?? ""}
          </div>
        </div>
      </div>
      <div className={`hayley-mt-4 ${isMaximized ? "hayley-w-[725px]" : "hayley-w-full"} hayley-rounded-md`}>
        <div className="hayley-mt-3 hayley-w-full hayley-max-w-[725px] hayley-bg-custom-7 ">
          <div className="hayley-w-full hayley-overflow-hidden">
            <iframe
              title="Google Map Preview"
              src={embedUrl}
              width="100%"
              height="260"
              className="block w-full h-[200px]"
              style={{
                border: "none",
                borderRadius: "4px",
                display: "block",
              }}
              loading="lazy"
              allowFullScreen
            />
          </div>
        </div>
      </div>
      {isLastBot ? <ExtraOption extraButtons={null} /> : null}
    </div>
  );
};

export default EmbedMapView;
